(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardViewController', EventDashboardViewController);

    EventDashboardViewController.$inject = ['$filter', '$stateParams', '$window', 'EventDashboard', 'AlertService',
        'EventFormCategory', 'EntiteParente', 'Agence'];

    function EventDashboardViewController($filter, $stateParams, $window, EventDashboard, AlertService,
                                          EventFormCategory, EntiteParente, Agence) {
        var vm = this;

        vm.dashboard = {};
        vm.config = {};
        vm.tableColumns = [];
        vm.tableEvents = [];
        vm.tableSummaries = [];
        vm.metrics = [];
        vm.histograms = [];
        vm.pies = [];
        vm.timeHistograms = [];
        vm.activeFilters = [];
        vm.totalBaseResults = 0;
        vm.tableTotalResults = 0;
        vm.tablePage = 1;
        vm.tablePageSize = 50;
        vm.map = buildEmptyMapState();
        vm.mapMarkerCount = 0;
        vm.isExporting = false;
        vm.isLoading = false;
        vm.searchText = null;
        vm.date = defaultDateRange();
        vm.useEncodingPeriod = false;
        vm.validityDate = new Date();
        vm.validityStatus = 'ACTIVE';
        vm.listCategory = [];
        vm.listSubCategory = [];
        vm.agencies = [];
        vm.areas = [];
        vm.filteredAreas = [];
        vm.selectedAgencyId = null;
        vm.selectedAreaId = null;
        vm.selectedCategoryId = null;
        vm.selectedSubCategoryId = null;
        vm.allowedCategoryIds = [];
        vm.allowedSubCategoryIds = [];

        vm.load = load;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.changePage = changePage;
        vm.maxValue = maxValue;
        vm.applyQuickFilter = applyQuickFilter;
        vm.removeFilter = removeFilter;
        vm.clearFilters = clearFilters;
        vm.exportAll = exportAll;
        vm.resolveDisplayValue = resolveDisplayValue;
        vm.resolveRawValue = resolveRawValue;
        vm.updateSubCategory = updateSubCategory;
        vm.updateAreaOptions = updateAreaOptions;
        vm.timeHistogramBaseType = timeHistogramBaseType;

        EventDashboard.get({id: $stateParams.id}, function(result) {
            vm.dashboard = result;
            vm.config = normalizeConfig(parseJson(result.configJson, {}));
            vm.tableColumns = resolveTableColumns(vm.config.table);
            vm.allowedCategoryIds = parseIds(result.categoryIds);
            vm.allowedSubCategoryIds = parseIds(result.subCategoryIds);
            loadReferenceData();
            load();
        }, onError);

        function loadReferenceData() {
            EntiteParente.query({
                page: 0,
                size: 500
            }, function(result) {
                vm.agencies = result || [];
            }, onError);

            Agence.currentOrganisation(function(result) {
                vm.areas = result || [];
                updateAreaOptions();
            }, onError);

            EventFormCategory.query({
                page: 0,
                size: 500
            }, function(result) {
                vm.listCategory = filterAllowedCategories(result || []);
            }, onError);
        }

        function load() {
            vm.isLoading = true;
            EventDashboard.viewData({id: vm.dashboard.id}, buildViewRequest(), function(result) {
                vm.tableEvents = prepareEvents(result.events || []);
                vm.totalBaseResults = result.totalBaseResults || 0;
                vm.tableTotalResults = result.totalFilteredResults || 0;
                vm.metrics = result.metrics || [];
                vm.histograms = result.histograms || [];
                vm.pies = result.pies || [];
                vm.tableSummaries = result.tableSummaries || [];
                vm.timeHistograms = prepareTimeHistograms(result.timeHistograms || []);
                vm.map = buildMapStateFromMarkers(result.mapMarkers || []);
                vm.mapMarkerCount = (result.mapMarkers || []).length;
                vm.isLoading = false;
            }, function(error) {
                vm.isLoading = false;
                onError(error);
            });
        }

        function search() {
            vm.tablePage = 1;
            load();
        }

        function resetFilters() {
            vm.searchText = null;
            vm.date = defaultDateRange();
            vm.useEncodingPeriod = false;
            vm.validityDate = new Date();
            vm.validityStatus = 'ACTIVE';
            vm.selectedAgencyId = null;
            vm.selectedAreaId = null;
            vm.selectedCategoryId = null;
            vm.selectedSubCategoryId = null;
            vm.listSubCategory = [];
            vm.activeFilters = [];
            updateAreaOptions();
            vm.tablePage = 1;
            load();
        }

        function changePage() {
            load();
        }

        function updateSubCategory() {
            vm.selectedSubCategoryId = null;
            if (!vm.selectedCategoryId) {
                vm.listSubCategory = [];
                return;
            }
            EventFormCategory.getListSubCategory({id: vm.selectedCategoryId}, function(result) {
                vm.listSubCategory = filterAllowedSubCategories(result || []);
            }, onError);
        }

        function updateAreaOptions() {
            vm.filteredAreas = (vm.areas || []).filter(function(area) {
                return !vm.selectedAgencyId || (area.entiteParente && area.entiteParente.id === vm.selectedAgencyId);
            });

            if (vm.selectedAreaId && !vm.filteredAreas.some(function(area) {
                return area.id === vm.selectedAreaId;
            })) {
                vm.selectedAreaId = null;
            }
        }

        function applyQuickFilter(fieldCode, rawValue, label, tokenOverride, valueLabelOverride) {
            var token = tokenOverride || normalizeFilterValue(rawValue, fieldCode);
            var valueLabel = valueLabelOverride || formatFilterValue(rawValue, fieldCode);
            var alreadyPresent = false;

            angular.forEach(vm.activeFilters, function(filter) {
                if (!alreadyPresent && filter.fieldCode === fieldCode && filter.token === token) {
                    alreadyPresent = true;
                }
            });

            if (alreadyPresent) {
                return;
            }

            vm.activeFilters.push({
                fieldCode: fieldCode,
                label: label || defaultFieldLabel(fieldCode),
                token: token,
                valueLabel: valueLabel
            });
            vm.tablePage = 1;
            load();
        }

        function removeFilter(index) {
            vm.activeFilters.splice(index, 1);
            vm.tablePage = 1;
            load();
        }

        function clearFilters() {
            vm.activeFilters = [];
            vm.tablePage = 1;
            load();
        }

        function exportAll() {
            vm.isExporting = true;
            EventDashboard.exportData({id: vm.dashboard.id}, buildViewRequest(false), function(result) {
                var exportEvents = prepareEvents(result || []);
                var csvContent = buildCsv(exportEvents, vm.tableColumns);
                downloadCsv(csvContent, buildExportFileName());
                vm.isExporting = false;
            }, function(error) {
                vm.isExporting = false;
                onError(error);
            });
        }

        function buildViewRequest(includePaging) {
            return {
                searchText: vm.searchText,
                fromDate: (!vm.config.validity.enabled || vm.useEncodingPeriod) && vm.date && vm.date.startDate
                    ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                toDate: (!vm.config.validity.enabled || vm.useEncodingPeriod) && vm.date && vm.date.endDate
                    ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null,
                validityDate: vm.config.validity.enabled ? formatLocalDate(vm.validityDate) : null,
                validityStatus: vm.config.validity.enabled ? vm.validityStatus : null,
                categoryIds: vm.selectedCategoryId ? [vm.selectedCategoryId] : null,
                subCategoryIds: vm.selectedSubCategoryId ? [vm.selectedSubCategoryId] : null,
                agencyIds: vm.selectedAgencyId ? [vm.selectedAgencyId] : null,
                areaIds: vm.selectedAreaId ? [vm.selectedAreaId] : null,
                quickFilters: angular.copy(vm.activeFilters),
                page: includePaging === false ? 0 : vm.tablePage - 1,
                size: includePaging === false ? null : vm.tablePageSize
            };
        }

        function prepareEvents(events) {
            return (events || []).map(function(event) {
                event._answers = parseJson(event.answersJson, {});
                event._fieldMappings = buildFieldMappings(parseJson(event.subCategoryCustomFields, {}));
                addValidityFieldMappings(event._fieldMappings);
                return event;
            });
        }

        function resolveDisplayValue(event, column) {
            var fieldCode = angular.isObject(column) ? column.fieldCode : column;
            var format = angular.isObject(column) ? column.format : null;
            var value = resolveRawValue(event, fieldCode);

            if (value === null || value === undefined || value === '') {
                return '';
            }
            if (format === 'number') {
                return numericValue(value);
            }
            if (format === 'date') {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (format === 'datetime') {
                return $filter('date')(value, 'short');
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'short');
            }
            if (angular.isNumber(value)) {
                return value;
            }
            if (typeof value === 'boolean') {
                return value ? 'Oui' : 'Non';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return value;
        }

        function resolveRawValue(event, column) {
            var fieldCode = angular.isObject(column) ? column.fieldCode : column;
            return resolveFieldValue(event, fieldCode);
        }

        function resolveFieldValue(event, fieldCode) {
            var directValue;
            var candidateCodes;
            var mapping;
            var index;

            if (!event) {
                return null;
            }

            directValue = resolveBuiltInFieldValue(event, fieldCode);
            if (directValue !== undefined) {
                return directValue;
            }

            if (!event._answers) {
                return null;
            }
            if (event._answers[fieldCode] !== undefined) {
                return event._answers[fieldCode];
            }

            candidateCodes = [fieldCode];
            mapping = event._fieldMappings[fieldCode];
            if (mapping) {
                candidateCodes = candidateCodes.concat(mapping.candidateCodes);
            }

            for (index = 0; index < candidateCodes.length; index++) {
                if (event._answers[candidateCodes[index]] !== undefined) {
                    return event._answers[candidateCodes[index]];
                }
            }

            return null;
        }

        function resolveBuiltInFieldValue(event, fieldCode) {
            if (!fieldCode) {
                return undefined;
            }

            switch (fieldCode) {
            case 'id':
                return event.id;
            case 'dateRecord':
                return event.dateRecord;
            case 'category':
                return event.category;
            case 'categoryId':
                return event.categoryId;
            case 'subCategory':
                return event.subCategory;
            case 'subCategoryId':
                return event.subCategoryId;
            case 'title':
                return event.title;
            case 'comment':
                return event.comment;
            case 'author':
                return event.author;
            case 'workflowStatus':
                return event.workflowStatus;
            case 'documentVersion':
                return event.documentVersion;
            case 'statusChangedDate':
                return event.statusChangedDate;
            case 'statusChangedBy':
                return event.statusChangedBy;
            case 'lat':
                return event.lat;
            case 'lon':
                return event.lon;
            case 'gps':
                return event.lat !== null && event.lat !== undefined && event.lon !== null && event.lon !== undefined
                    ? event.lat + ', ' + event.lon : null;
            case 'area':
            case 'areaName':
                return event.areaName;
            case 'areaId':
                return event.areaId;
            case 'agency':
            case 'agencyName':
                return event.agencyName;
            case 'agencyId':
                return event.agencyId;
            default:
                return undefined;
            }
        }

        function buildFieldMappings(customFieldsConfig) {
            var mappings = {};

            angular.forEach((customFieldsConfig && customFieldsConfig.fields) || [], function(fieldConfig) {
                var dictionaryFieldCode = fieldConfig.dictionaryFieldCode || fieldConfig.fieldCode;
                var storageName = fieldConfig.name || fieldConfig.code || dictionaryFieldCode;
                var mappingKey = dictionaryFieldCode || storageName;

                if (!mappingKey) {
                    return;
                }

                mappings[mappingKey] = {
                    candidateCodes: uniqueCodes([storageName, dictionaryFieldCode].concat(parseLegacyNames(fieldConfig.legacyNames || fieldConfig.legacyCodes)))
                };
                if (storageName && !mappings[storageName]) {
                    mappings[storageName] = mappings[mappingKey];
                }
            });

            return mappings;
        }

        function addValidityFieldMappings(mappings) {
            if (!vm.config.validity.enabled) {
                return;
            }
            angular.forEach([
                {code: vm.config.validity.startFieldCode, names: vm.config.validity.startLegacyNames},
                {code: vm.config.validity.endFieldCode, names: vm.config.validity.endLegacyNames}
            ], function(field) {
                if (!field.code || !angular.isArray(field.names) || !field.names.length) {
                    return;
                }
                var existing = mappings[field.code] ? mappings[field.code].candidateCodes : [];
                mappings[field.code] = {candidateCodes: uniqueCodes(existing.concat(field.names))};
            });
        }

        function uniqueCodes(values) {
            var seen = {};
            var result = [];

            angular.forEach(values, function(value) {
                if (!value || seen[value]) {
                    return;
                }
                seen[value] = true;
                result.push(value);
            });

            return result;
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function buildCsv(events, columns) {
            var lines = [];
            var exportColumns = columns && columns.length ? columns : defaultTableColumns();

            lines.push(exportColumns.map(function(column) {
                return escapeCsvValue(column.label);
            }).join(';'));

            angular.forEach(events, function(event) {
                lines.push(exportColumns.map(function(column) {
                    return escapeCsvValue(resolveDisplayValue(event, column));
                }).join(';'));
            });

            return '\ufeff' + lines.join('\r\n');
        }

        function buildExportFileName() {
            var safeCode = vm.dashboard.code || 'dashboard-evenements';
            return safeCode + '-' + $filter('date')(new Date(), 'yyyyMMdd-HHmmss') + '.csv';
        }

        function downloadCsv(content, fileName) {
            var blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});

            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }

            var url = $window.URL.createObjectURL(blob);
            var link = $window.document.createElement('a');
            link.href = url;
            link.download = fileName;
            $window.document.body.appendChild(link);
            link.click();
            $window.document.body.removeChild(link);
            $window.URL.revokeObjectURL(url);
        }

        function escapeCsvValue(value) {
            var text = value === null || value === undefined ? '' : String(value);
            return '"' + text.replace(/"/g, '""') + '"';
        }

        function normalizeFilterValue(value, fieldCode) {
            if (value === null || value === undefined || value === '') {
                return '__blank__';
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (typeof value === 'boolean') {
                return value ? 'true' : 'false';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return String(value).trim().toLowerCase();
        }

        function formatFilterValue(value, fieldCode) {
            if (value === null || value === undefined || value === '') {
                return 'Non renseigné';
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (typeof value === 'boolean') {
                return value ? 'Oui' : 'Non';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return String(value);
        }

        function normalizeConfig(rawConfig) {
            var config = angular.isObject(rawConfig) ? angular.copy(rawConfig) : {};
            config.metrics = normalizeMetricConfigs(config.metrics);
            config.histograms = normalizeChartConfigs(config.histograms);
            config.pies = normalizeChartConfigs(config.pies);
            config.table = normalizeTableConfig(config.table);
            config.map = normalizeMapConfig(config.map);
            config.validity = config.validity && config.validity.enabled ? config.validity : {enabled: false};
            return config;
        }

        function formatLocalDate(value) {
            if (!value) {
                return null;
            }
            return value.getFullYear() + '-' + ('0' + (value.getMonth() + 1)).slice(-2)
                + '-' + ('0' + value.getDate()).slice(-2);
        }

        function normalizeMetricConfigs(metrics) {
            var normalized = [];

            angular.forEach(metrics || [], function(metric) {
                normalized.push({
                    fieldCode: metric.fieldCode || null,
                    label: metric.label || null,
                    aggregation: metric.aggregation || 'sum'
                });
            });

            return normalized;
        }

        function normalizeChartConfigs(charts) {
            var normalized = [];

            angular.forEach(charts || [], function(chart) {
                var groupByFieldCode = chart.groupByFieldCode || chart.fieldCode;
                if (!groupByFieldCode) {
                    return;
                }
                normalized.push({
                    groupByFieldCode: groupByFieldCode,
                    valueFieldCode: chart.valueFieldCode || chart.metricFieldCode || null,
                    label: chart.label || null,
                    aggregation: chart.aggregation || 'count',
                    limit: toPositiveInteger(chart.limit, 20)
                });
            });

            return normalized;
        }

        function normalizeTableConfig(tableConfig) {
            if (tableConfig === false) {
                return {
                    enabled: false,
                    columns: [],
                    summaries: []
                };
            }

            if (tableConfig === true || tableConfig === null || tableConfig === undefined) {
                return {
                    enabled: true,
                    columns: defaultTableColumns(),
                    summaries: []
                };
            }

            return {
                enabled: tableConfig.enabled !== false,
                columns: angular.isArray(tableConfig.columns) ? tableConfig.columns : defaultTableColumns(),
                summaries: angular.isArray(tableConfig.summaries) ? tableConfig.summaries : []
            };
        }

        function normalizeMapConfig(mapConfig) {
            if (mapConfig === false) {
                return {enabled: false};
            }
            if (mapConfig === true || mapConfig === null || mapConfig === undefined) {
                return {enabled: true};
            }
            return {
                enabled: mapConfig.enabled !== false
            };
        }

        function resolveTableColumns(tableConfig) {
            var configuredColumns = (tableConfig && tableConfig.columns) || [];
            var columns = [];

            if (!configuredColumns.length) {
                return defaultTableColumns();
            }

            angular.forEach(configuredColumns, function(column) {
                var fieldCode = column.fieldCode || column.code;
                if (!fieldCode) {
                    return;
                }
                columns.push({
                    fieldCode: fieldCode,
                    label: column.label || defaultFieldLabel(fieldCode),
                    format: column.format || null
                });
            });

            return columns.length ? columns : defaultTableColumns();
        }

        function defaultTableColumns() {
            return [
                {fieldCode: 'dateRecord', label: 'Date'},
                {fieldCode: 'category', label: 'Catégorie'},
                {fieldCode: 'subCategory', label: 'Sous-catégorie'},
                {fieldCode: 'title', label: 'Titre'},
                {fieldCode: 'author', label: 'Auteur'}
            ];
        }

        function defaultFieldLabel(fieldCode) {
            switch (fieldCode) {
            case 'dateRecord':
                return 'Date';
            case 'category':
                return 'Catégorie';
            case 'subCategory':
                return 'Sous-catégorie';
            case 'title':
                return 'Titre';
            case 'author':
                return 'Auteur';
            case 'comment':
                return 'Commentaire';
            case 'workflowStatus':
                return 'État';
            case 'documentVersion':
                return 'Version';
            case 'statusChangedDate':
                return 'Date de changement d\'état';
            case 'statusChangedBy':
                return 'Modifié par';
            case 'gps':
                return 'Coordonnées GPS';
            case 'agency':
            case 'agencyName':
                return 'Agence';
            case 'area':
            case 'areaName':
                return 'Zone';
            default:
                return fieldCode;
            }
        }

        function isDateValue(fieldCode, value) {
            if (!value) {
                return false;
            }
            if (fieldCode === 'dateRecord' || fieldCode === 'statusChangedDate') {
                return true;
            }
            return angular.isDate(value) || /^\d{4}-\d{2}-\d{2}T/.test(String(value)) || /^\d{4}-\d{2}-\d{2}$/.test(String(value));
        }

        function parseJson(value, defaultValue) {
            if (!value) {
                return defaultValue;
            }
            try {
                return angular.fromJson(value);
            } catch (e) {
                return defaultValue;
            }
        }

        function numericValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            var parsed = Number(value);
            return isNaN(parsed) ? null : parsed;
        }

        function maxValue(values) {
            var max = 0;
            angular.forEach(values || [], function(value) {
                if (value.value > max) {
                    max = value.value;
                }
            });
            return max || 1;
        }

        function parseIds(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value.map(function(item) {
                    return parseInt(item, 10);
                }).filter(function(item) {
                    return !isNaN(item);
                });
            }
            return String(value).split(',').map(function(item) {
                return parseInt(item.trim(), 10);
            }).filter(function(item) {
                return !isNaN(item);
            });
        }

        function filterAllowedCategories(categories) {
            if (!vm.allowedCategoryIds.length) {
                return categories;
            }
            return (categories || []).filter(function(category) {
                return vm.allowedCategoryIds.indexOf(category.id) !== -1;
            });
        }

        function filterAllowedSubCategories(subCategories) {
            if (!vm.allowedSubCategoryIds.length) {
                return subCategories;
            }
            return (subCategories || []).filter(function(subCategory) {
                return vm.allowedSubCategoryIds.indexOf(subCategory.id) !== -1;
            });
        }

        function prepareTimeHistograms(histograms) {
            return (histograms || []).map(function(histogram) {
                var preparedHistogram = angular.copy(histogram);
                preparedHistogram.seriesLabels = [];
                preparedHistogram.data = [];
                preparedHistogram.datasetOverride = [];
                angular.forEach(preparedHistogram.series || [], function(series) {
                    preparedHistogram.seriesLabels.push(series.label);
                    preparedHistogram.data.push(series.values || []);
                    preparedHistogram.datasetOverride.push({
                        label: series.label,
                        type: series.displayType || 'bar',
                        fill: false,
                        borderWidth: series.displayType === 'line' ? 2 : 1
                    });
                });
                preparedHistogram.baseType = preparedHistogram.datasetOverride.length
                    ? (preparedHistogram.datasetOverride[0].type || 'bar') : 'bar';
                preparedHistogram.options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                };
                return preparedHistogram;
            });
        }

        function timeHistogramBaseType(histogram) {
            return histogram && histogram.baseType ? histogram.baseType : 'bar';
        }

        function buildMapStateFromMarkers(markers) {
            if (!markers || !markers.length) {
                return buildEmptyMapState();
            }

            var mapState = buildEmptyMapState();
            var firstMarker = null;
            var bounds = initBounds();

            angular.forEach(markers, function(marker, index) {
                var markerKey = 'event_' + index;
                mapState.markers[markerKey] = {
                    lat: marker.lat,
                    lng: marker.lng,
                    message: marker.message,
                    draggable: false
                };

                if (!firstMarker) {
                    firstMarker = mapState.markers[markerKey];
                }
                updateBounds(bounds, marker.lat, marker.lng);
            });

            mapState.center = {
                lat: firstMarker.lat,
                lng: firstMarker.lng,
                zoom: markers.length > 1 ? 12 : 16
            };

            if (markers.length > 1) {
                mapState.bounds = buildBoundsObject(bounds);
            }

            return mapState;
        }

        function buildEmptyMapState() {
            return {
                center: {
                    lat: 0,
                    lng: 0,
                    zoom: 2
                },
                bounds: null,
                markers: {},
                defaults: {
                    scrollWheelZoom: false
                },
                layers: {
                    baselayers: {
                        osm: {
                            name: 'OpenStreetMap',
                            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                            type: 'xyz'
                        },
                        satellite: {
                            name: 'Satellite',
                            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                            type: 'xyz'
                        }
                    }
                }
            };
        }

        function initBounds() {
            return {
                minLat: Number.POSITIVE_INFINITY,
                maxLat: Number.NEGATIVE_INFINITY,
                minLon: Number.POSITIVE_INFINITY,
                maxLon: Number.NEGATIVE_INFINITY
            };
        }

        function updateBounds(bounds, lat, lon) {
            bounds.minLat = Math.min(bounds.minLat, lat);
            bounds.maxLat = Math.max(bounds.maxLat, lat);
            bounds.minLon = Math.min(bounds.minLon, lon);
            bounds.maxLon = Math.max(bounds.maxLon, lon);
        }

        function buildBoundsObject(bounds) {
            return {
                northEast: {
                    lat: bounds.maxLat,
                    lng: bounds.maxLon
                },
                southWest: {
                    lat: bounds.minLat,
                    lng: bounds.minLon
                }
            };
        }

        function toPositiveInteger(value, defaultValue) {
            var parsed = parseInt(value, 10);
            return isNaN(parsed) || parsed <= 0 ? defaultValue : parsed;
        }

        function defaultDateRange() {
            var today = new Date();
            return {
                startDate: new Date(today.getFullYear(), today.getMonth() - 11, 1),
                endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
            };
        }

        function onError(error) {
            var message = error && error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du tableau de bord.';
            AlertService.error(message);
        }
    }
})();
